import React, { useMemo, useState, useEffect } from 'react';
import StickyTitle from '../components/StickyTitle.js';
import { MaterialReactTable } from 'material-react-table';
import { Button } from '@mui/material';
import NewItemServiceForm from "../components/NewItemServiceForm.js"
import axios from "axios";
import { CSVLink } from "react-csv";
import { useAuth } from '../../AuthContext.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ItemServicesPage = () => {

  const { userRole } = useAuth()
  const [employee, setEmployee]= useState(true);

  useEffect (()=>{
    if (userRole === "manager") {
      setEmployee(false)
    } else{
      setEmployee(true)
    };
  },[userRole])

  let [selectedRow, setSelectedRow] = useState(null);
  let [selectedRowData, setSelectedRowData] = useState(null);
  const [isNewItemServiceFormOpen, setIsNewItemServiceFormOpen] = useState(false);

  const openNewItemServiceForm = () => {
    setIsNewItemServiceFormOpen(true);
    setSelectedRowData(null);
  };

  // Function to close the form
  const closeNewItemServiceForm = () => {
    setIsNewItemServiceFormOpen(false);
  };

  const [data, setData] = useState([]);
  const [itemData, setItemData] = useState([]);
  const [serviceData, setServiceData] = useState([]);

  useEffect(() => {
    const fetchAllItemServices = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/itemservices/all_itemservices`)
        const responseData = await response.json();
        setData(responseData.itemservice);
        // Separate data for "item" and "service" types
        const itemData = responseData.itemservice.filter(item => item.type === "Item");
        const serviceData = responseData.itemservice.filter(item => item.type === "Service");
        setItemData(itemData);
        setServiceData(serviceData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchAllItemServices();
  }, [isNewItemServiceFormOpen])

  const delete_itemservice = async (selectedRowId) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/itemservices/delete_itemservice`, {
        data:{
          id:selectedRowId
        }
      })
      if(response.status===200)
      {
        toast.success(`Item/service with id: "${selectedRowId}" deleted successfully.`)
      }
    } catch (error) {
      toast.error("Error deleting Item/service")
    }
  }

  const columns = useMemo(
    () => [
      {
        accessorKey: 'id', //access nested data with dot notation
        header: 'Id',
        size: 100,
      },
      {
        accessorKey: 'itemservice', //access nested data with dot notation
        header: 'Item',
        size: 100,
      },
      {
        accessorKey: 'currentstock', //normal accessorKey
        header: 'Current Stock',
        size: 200,
      },
      {
        accessorKey: 'vendor_name',
        header: 'Vendor',
        size: 100,
        Cell: ({ cell }) => (
          `${cell.getValue() ? cell.getValue() : "Unavailable"}`
        )
      },
    ],
    [],
  );

  const columns2 = useMemo(
    () => [
      {
        accessorKey: 'id', //access nested data with dot notation
        header: 'Id',
        size: 100,
      },
      {
        accessorKey: 'itemservice', //access nested data with dot notation
        header: 'Service',
        size: 100,
      },
    ],
    [],
  );

  return (
    <>
      <StickyTitle title="Items & Services" button_action={openNewItemServiceForm} menubutton={false} button="New Item/Service" />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className='px-4 lg:px-16 py-4 lg:py-10 flex flex-col gap-0 overflow-x-auto'>
      <div className="table-filters flex flex-row items-center justify-between mt-3 md:mb-[50px]">
        <div className='text-2xl ml-5 font-bold font-poppins'>Items</div>
      </div>

      <div className="w-ful mb-10">
        <MaterialReactTable
          // enableRowActions
          enableRowSelection
          columns={columns}
          data={itemData}
          renderTopToolbarCustomActions={({ table }) => {
            const handleDelete = () => {
              const selectedRows = table.getSelectedRowModel().flatRows;

              if (selectedRows.length === 1) {
                selectedRow = selectedRows[0];
                const selectedRowId = selectedRow.original.id;
                setSelectedRow(selectedRow);
                alert('Deleting ItemService with ID: ' + selectedRowId);
                delete_itemservice(selectedRowId)
              } else {
                alert('Please select a single row to delete.');
              }
            };
            const handleEdit = () => {
              const selectedRows = table.getSelectedRowModel().flatRows;

              if (selectedRows.length === 1) {
                const selectedRow = selectedRows[0];
                selectedRowData = selectedRow.original;
                setSelectedRowData(selectedRowData);
                setIsNewItemServiceFormOpen(true);
              } else {
                alert('Please select a single row to Edit.');
              }
            };


            return (
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <Button
                  color="error"
                  disabled={!table.getIsSomeRowsSelected()}
                  onClick={handleDelete}
                  variant="contained"
                  sx={employee ? {display: 'none'} : { }}
                >
                  Delete
                </Button>
                <Button
                  color="success"
                  disabled={!table.getIsSomeRowsSelected()}
                  onClick={handleEdit}
                  variant="contained"
                >
                  Edit
                </Button>
                <Button
                  color="success"
                  variant="contained"
                >
                  <CSVLink data={data}>Export to CSV</CSVLink>
                </Button>
              </div>
            );
          }}
        />
      </div>

      <div className="table-filters flex flex-row items-center justify-between mb-5">
        <div className='text-2xl font-bold font-poppins'>Services</div>
      </div>

      <div className="w-full">
        <MaterialReactTable
          // enableRowActions
          enableRowSelection
          columns={columns2}
          data={serviceData}
          renderTopToolbarCustomActions={({ table }) => {
            const handleDelete = () => {
              const selectedRows = table.getSelectedRowModel().flatRows;

              if (selectedRows.length === 1) {
                selectedRow = selectedRows[0];
                const selectedRowId = selectedRow.original.id;
                setSelectedRow(selectedRow);
                alert('Deleting ItemService with ID: ' + selectedRowId);
                delete_itemservice(selectedRowId)
              } else {
                alert('Please select a single row to delete.');
              }
            };
            const handleEdit = () => {
              const selectedRows = table.getSelectedRowModel().flatRows;

              if (selectedRows.length === 1) {
                const selectedRow = selectedRows[0];
                selectedRowData = selectedRow.original;
                setSelectedRowData(selectedRowData);
                setIsNewItemServiceFormOpen(true);
              } else {
                alert('Please select a single row to Edit.');
              }
            };


            return (
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <Button
                  color="error"
                  disabled={!table.getIsSomeRowsSelected()}
                  onClick={handleDelete}
                  variant="contained"
                  sx={employee ? {display: 'none'} : { }}
                >
                  Delete
                </Button>
                <Button
                  color="success"
                  disabled={!table.getIsSomeRowsSelected()}
                  onClick={handleEdit}
                  variant="contained"
                >
                  Edit
                </Button>
                <Button
                  color="success"
                  variant="contained"
                >
                  <CSVLink data={data}>Export to CSV</CSVLink>
                </Button>
              </div>
            );
          }}
        />
      </div>
      </div>


      <NewItemServiceForm isOpen={isNewItemServiceFormOpen} onClose={closeNewItemServiceForm} selectedRowData={selectedRowData} />
    </>
  );
};

export default ItemServicesPage;
